quoteModule.factory('quoteInitializationService', ['$http','$q', 'erateSessionVarsService','rateQuoteCoordService','quoteIntegrationService','quoteIntegrationConstants',
function ($http, $q, erateSessionVarsService, rateQuoteCoordService, quoteIntegrationService, quoteIntegrationConstants) {
    var quoteInitializationService = {};

    var _childReadyStates = {
        vehicleReady : false,
        dealReady : false,
        customerReady : false
    };
    var _readyHandlers = {};

    quoteInitializationService.clearReadyStates = function(){
        _childReadyStates.vehicleReady = false;
        _childReadyStates.dealReady = false;
        _childReadyStates.customerReady = false;
    }
    quoteInitializationService.registerCallbackHandler = function(handler, key){
        //had a problem with multiple "registerCallbackHandler"s being pushed,
        // especially when searching quotes all the time
        if (!_readyHandlers[key])
            _readyHandlers[key] = handler;
    }
    quoteInitializationService.signalChildReady = function(prop){
        _childReadyStates[prop] = true;
        if (_childReadyStates.vehicleReady &&
            _childReadyStates.dealReady &&
            _childReadyStates.customerReady){
            for(var prop in _readyHandlers){
                if (_readyHandlers.hasOwnProperty(prop))
                    _readyHandlers[prop]();//execute the handler
            }
        }
    }

    //set up initial customer information
    quoteInitializationService.initializeCustomerData = function(){
        var quoteMode = erateSessionVarsService.getQuotingMode();

        var appPrefillData=null;
        if (quoteMode && (quoteMode == quoteIntegrationConstants.menuQuoteIntegrated ||
            quoteMode == quoteIntegrationConstants.menuContractIntegrated ||
            quoteMode == quoteIntegrationConstants.newQuoteIntegrated))
        {
            rateQuoteCoordService.clearCustomer();
            //if we are integrated, then let's grab the current customer "prefill" information and set our scope data
            appPrefillData = quoteIntegrationService.getIntegrationData();

            if (appPrefillData){
                if (appPrefillData.primaryBuyerInfo){
                    rateQuoteCoordService.CustomerData.BuyerInfo.firstName = appPrefillData.primaryBuyerInfo.firstName || '';
                    rateQuoteCoordService.CustomerData.BuyerInfo.middleName = appPrefillData.primaryBuyerInfo.middleName || '';
                    rateQuoteCoordService.CustomerData.BuyerInfo.lastName = appPrefillData.primaryBuyerInfo.lastName || '';
                    rateQuoteCoordService.CustomerData.customerNumber = appPrefillData.primaryBuyerInfo.customerNumber || '';
                    rateQuoteCoordService.CustomerData.address1 = appPrefillData.primaryBuyerInfo.address1 || '';
                    rateQuoteCoordService.CustomerData.address2 = appPrefillData.primaryBuyerInfo.address2 || '';
                    rateQuoteCoordService.CustomerData.city = appPrefillData.primaryBuyerInfo.city || '';
                    rateQuoteCoordService.CustomerData.state = appPrefillData.primaryBuyerInfo.state || '';
                    rateQuoteCoordService.CustomerData.zip = appPrefillData.primaryBuyerInfo.zip.indexOf('-') > -1 ? appPrefillData.primaryBuyerInfo.zip.substring(0,appPrefillData.primaryBuyerInfo.zip.indexOf('-')) : appPrefillData.primaryBuyerInfo.zip;
                    rateQuoteCoordService.CustomerData.phone1 = appPrefillData.primaryBuyerInfo.phone || '';
                }
                if (appPrefillData.coBuyerInfo){
                    rateQuoteCoordService.CustomerData.CoBuyerInfo.firstName = appPrefillData.coBuyerInfo.firstName || '';
                    rateQuoteCoordService.CustomerData.CoBuyerInfo.middleName = appPrefillData.coBuyerInfo.middleName || '';
                    rateQuoteCoordService.CustomerData.CoBuyerInfo.lastName = appPrefillData.coBuyerInfo.lastName || '';
                }
                if (appPrefillData.businessInfo) {
                    rateQuoteCoordService.CustomerData.BusinessInfo.businessName = appPrefillData.businessInfo.businessName || '';
                    rateQuoteCoordService.CustomerData.BusinessInfo.driverFirstName = appPrefillData.businessInfo.primaryDriverFirstName || '';
                    rateQuoteCoordService.CustomerData.BusinessInfo.driverLastName = appPrefillData.businessInfo.primaryDriverLastName || '';
                    rateQuoteCoordService.CustomerData.phone1 = appPrefillData.businessInfo.phone || '';
                    rateQuoteCoordService.CustomerData.address1 = appPrefillData.businessInfo.address1 || '';
                    rateQuoteCoordService.CustomerData.address2 = appPrefillData.businessInfo.address2 || '';
                    rateQuoteCoordService.CustomerData.city = appPrefillData.businessInfo.city || '';
                    rateQuoteCoordService.CustomerData.state = appPrefillData.businessInfo.state || '';
                    rateQuoteCoordService.CustomerData.zip = appPrefillData.businessInfo.zip || '';
                }
            }
        } else if(quoteMode && quoteMode == quoteIntegrationConstants.searchIntegrated) {
            rateQuoteCoordService.clearCustomer();
            appPrefillData = quoteIntegrationService.getIntegrationData();
            rateQuoteCoordService.CustomerData = appPrefillData && appPrefillData.customer ? appPrefillData.customer : new CustomerInfo();
        }
        else if (quoteMode && quoteMode == quoteIntegrationConstants.newQuoteIntegrated) {
            rateQuoteCoordService.clearCustomer();
            appPrefillData = quoteIntegrationService.getIntegrationData();
            for (var prop in appPrefillData.providerSpecific || {}) {
                if (appPrefillData.providerSpecific.hasOwnProperty(prop) && rateQuoteCoordService.CustomerData.hasOwnProperty(prop)) {
                    rateQuoteCoordService.CustomerData[prop] = appPrefillData.providerSpecific[prop];
                }
            }
        }
        appPrefillData = null;
    }
    //set up initial deal information
    quoteInitializationService.initializeDealData = function(){
        var quoteMode = erateSessionVarsService.getQuotingMode();
        rateQuoteCoordService.clearDeal();
        var appPrefillData = null;
        if (quoteMode && (quoteMode == quoteIntegrationConstants.menuQuoteIntegrated ||
            quoteMode == quoteIntegrationConstants.menuContractIntegrated ||
            quoteMode == quoteIntegrationConstants.newQuoteIntegrated))
        {
            //when we first start, let' pre-populate our scope data with integrated data sent
            appPrefillData = quoteIntegrationService.getIntegrationData();
            if (appPrefillData && appPrefillData.financialDatas && appPrefillData.financialDatas.length > 0) {
                //it is possible to have more than one financing option
                var primaryDeal = appPrefillData.financialDatas[0];
                rateQuoteCoordService.DealData.termMonths = primaryDeal.financingMonths ? parseInt(primaryDeal.financingMonths) : 0;
                rateQuoteCoordService.DealData.financeRate = primaryDeal.financingAPR ? parseFloat(primaryDeal.financingAPR) : 0;
                rateQuoteCoordService.DealData.amountFinanced = primaryDeal.amountFinanced ? parseFloat(primaryDeal.amountFinanced) : 0;
                rateQuoteCoordService.DealData.saleType = primaryDeal.saleType ? primaryDeal.saleType : (appPrefillData.saleType ? appPrefillData.saleType : "RetailFinanced");
                if (primaryDeal.sellingPrice)
                    rateQuoteCoordService.DealData.sellingPrice = parseFloat(primaryDeal.sellingPrice);
                else if (appPrefillData.providerSpecific && appPrefillData.providerSpecific['sellingPrice'])
                    rateQuoteCoordService.DealData.sellingPrice = parseFloat(appPrefillData.providerSpecific['sellingPrice']);
                else
                    rateQuoteCoordService.DealData.sellingPrice = 0;
                rateQuoteCoordService.DealData.MSRP = primaryDeal.vehicleMSRP ? parseFloat(primaryDeal.vehicleMSRP) : (primaryDeal.MSRP ? parseFloat(primaryDeal.MSRP) : 0);
                rateQuoteCoordService.DealData.etchNum = primaryDeal.etchNum;
            }
        } else if(quoteMode && quoteMode == quoteIntegrationConstants.searchIntegrated) {
            appPrefillData = quoteIntegrationService.getIntegrationData();
            rateQuoteCoordService.DealData = appPrefillData && appPrefillData.deal ? appPrefillData.deal : new DealInfo();
        }
        else if (quoteMode && quoteMode == quoteIntegrationConstants.newQuoteIntegrated) {
            appPrefillData = quoteIntegrationService.getIntegrationData();
            for (var prop in appPrefillData.providerSpecific || {}) {
                if (appPrefillData.providerSpecific.hasOwnProperty(prop) && rateQuoteCoordService.DealData.hasOwnProperty(prop)) {
                    rateQuoteCoordService.DealData[prop] = appPrefillData.providerSpecific[prop];
                }
            }
        }
        appPrefillData = null;
    }

    quoteInitializationService.initializeVehicleData = function(){
        var quoteMode = erateSessionVarsService.getQuotingMode();
        rateQuoteCoordService.clearVehicle();
        if (quoteMode && quoteMode == quoteIntegrationConstants.menuQuoteIntegrated ||
            quoteMode == quoteIntegrationConstants.menuContractIntegrated ||
            quoteMode == quoteIntegrationConstants.searchIntegrated ||
            quoteMode == quoteIntegrationConstants.newQuoteIntegrated)
        {   //we are integrated with another application.. So populate scope with data captured
            var appPrefillData = quoteIntegrationService.getIntegrationData();
            if (appPrefillData){
                if (appPrefillData.dateOfSale){
                    rateQuoteCoordService.VehicleData.dateOfSale = new Date(appPrefillData.dateOfSale);
                }
                if (appPrefillData.vehicleInfo){
                    if (appPrefillData.vehicleInfo.vin){
                        rateQuoteCoordService.VehicleData.vin = appPrefillData.vehicleInfo.vin;
                    }
                    if (appPrefillData.vehicleInfo.odometer){
                        rateQuoteCoordService.VehicleData.odometer = parseInt(appPrefillData.vehicleInfo.odometer);
                    }
                    if (appPrefillData.vehicleInfo.odometer){
                        rateQuoteCoordService.VehicleData.odometer = parseInt(appPrefillData.vehicleInfo.odometer);
                    }if (appPrefillData.vehicleInfo.odometer){
                        rateQuoteCoordService.VehicleData.odometer = parseInt(appPrefillData.vehicleInfo.odometer);
                    }
                    if (appPrefillData.vehicleInfo.newUsed){
                        rateQuoteCoordService.VehicleData.newUsed = appPrefillData.vehicleInfo.newUsed;
                    }
                    rateQuoteCoordService.VehicleData.vehicleType = 'AUTO';
                    if (appPrefillData.vehicleInfo.rvType){
                        rateQuoteCoordService.VehicleData.vehicleType = 'RV';
                        rateQuoteCoordService.VehicleData.rvType = appPrefillData.vehicleInfo.rvType;
                        rateQuoteCoordService.VehicleData.rvManuMonths = appPrefillData.vehicleInfo.wMonths;
                        rateQuoteCoordService.VehicleData.rvManuMiles = appPrefillData.vehicleInfo.wMiles;
                        rateQuoteCoordService.VehicleData.year = appPrefillData.vehicleInfo.modelYear;
                    }
                }
                if (appPrefillData.providerSpecific) {
                    for (var prop in appPrefillData.providerSpecific) {
                        if (appPrefillData.providerSpecific.hasOwnProperty(prop) && rateQuoteCoordService.VehicleData.hasOwnProperty(prop)) {
                            rateQuoteCoordService.VehicleData[prop] = appPrefillData.providerSpecific[prop];
                        }
                    }
                }
            }
        }
    }

    // Parses a date in either mm/dd/yyyy or mm-dd-yyyy format
    function parseMmDdYyyy(date) {
        var splitOn = date.indexOf('/') >= 0 ? '/' : '-';
        var dateSplit = date.split(splitOn);
        return new Date(parseInt(dateSplit[2]),parseInt(dateSplit[0])-1,parseInt(dateSplit[1]));
    }
    return quoteInitializationService;
}]);
